import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emoji'
})
export class EmojiPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value) return value;
    let result = value;
    result = jEmoji.softbankToUnified(result);
    result = jEmoji.googleToUnified(result);
    result = jEmoji.docomoToUnified(result);
    result = jEmoji.kddiToUnified(result);
    return result;
  }
}
